export type VatechCtMatchStrategy = "db_patient_id" | "patient_name" | "both" | "unknown" | "mixed"

export type VatechCtCatalogStudy = {
  study_uid: string
  study_date: string | null
  folder_name?: string | null
  raw_folder_name?: string | null
  patient_id?: string | null
  patient_name?: string | null
  modality?: string | null
  slice_count?: number | null
  match_strategy?: VatechCtMatchStrategy | string | null
  patient_linked: boolean
  submit_eligible: boolean
  already_in_diagnocat: boolean
  diagnocat_analyses_count?: number
  diagnocat_analysis_ready?: boolean
  diagnocat_analyses_ready_count?: number
}

export type VatechCtCatalogResolved = {
  success: boolean
  mis_patient_id?: string | null
  lk_patient_id?: number | null
  local_patient_id: number | null
  fullname: string | null
  patient_linked: boolean
  resolve_strategy: VatechCtMatchStrategy | string | null
  studies: VatechCtCatalogStudy[]
  total: number
}

export function describeMatchStrategy(strategy: string | null | undefined): string {
  switch (strategy) {
    case "db_patient_id":
      return "по ID пациента"
    case "patient_name":
      return "по ФИО"
    case "both":
      return "ID + ФИО"
    case "mixed":
      return "смешанный"
    default:
      return strategy ?? "неизвестно"
  }
}

export function dedupeVatechStudies(studies: VatechCtCatalogStudy[]): VatechCtCatalogStudy[] {
  const seen = new Set<string>()
  const result: VatechCtCatalogStudy[] = []
  for (const study of studies) {
    const key = study.study_uid?.trim()
    if (!key || seen.has(key)) continue
    seen.add(key)
    result.push(study)
  }
  return result
}

export function pickDefaultVatechStudy(studies: VatechCtCatalogStudy[]): VatechCtCatalogStudy | null {
  const withAnalysis = studies.filter((s) => s.diagnocat_analysis_ready)
  if (withAnalysis.length > 0) {
    return [...withAnalysis].sort((a, b) => (b.study_date ?? "").localeCompare(a.study_date ?? ""))[0]
  }
  const eligible = studies.filter((s) => s.submit_eligible && !s.already_in_diagnocat)
  if (eligible.length === 0) {
    const withUid = studies.filter((s) => s.study_uid)
    if (withUid.length === 0) return null
    return [...withUid].sort((a, b) => (b.study_date ?? "").localeCompare(a.study_date ?? ""))[0]
  }
  return [...eligible].sort((a, b) => (b.study_date ?? "").localeCompare(a.study_date ?? ""))[0]
}
